import React, { Component } from 'react';
import { Header } from '../layout';
import HelpPageComponent from './help-page.component';
import { Title } from '../layout';

export class PublicHelpPageComponent extends Component {
  render() {
    return (
      <div>
        <Title title="Help"/>
        <Header />
        <div className="container">
          <HelpPageComponent />
        </div>
      </div>
    );
  }
}

export default PublicHelpPageComponent;



// WEBPACK FOOTER //
// src/help/public-help-page.component.js